import { Badge } from "@/components/ui/Badge";
import { ActionDropdown, EditDropdownMenuItem } from "../../components/ui/actions/ActionDropdown";

export const getPatientColumns = ({ onListAction, onEdit }) => {

  const onAction = (action, key) => {
    if (action === 'edit') {
      onEdit(key);
      return;
    }
  }

  return [
    {
      title: 'Name',
      key: 'actualName',
      sort: true,
      render: (row) => row.actualName,
      width: '200px'
    },
    {
      title: 'Gender',
      key: 'gender',
      render: (row) => {
        return <Badge variant={row.gender === 'Male' ? 'success' : 'warning'}>{row.gender}</Badge>
      }
    },
    {
      title: 'Birth Date',
      key: 'birthDate',
      render: (row) => row.birthDate
    },
    {
      title: 'CNIC',
      key: 'cnic',
      render: (row) => row.cnic
    },
    {
      title: 'Phone',
      key: 'phone',
      render: (row) => row.phone
    },
    {
      title: 'Email',
      key: 'email',
      render: (row) => row.email
    },
    {
      title: '',
      isPlaceholder: true,
      key: null,
      render: (row) => {
        return (
          <div class="flex gap-2 items-center">
            <ActionDropdown asIcon>
              <EditDropdownMenuItem onClick={() => { onAction('edit', row.key) }} />
            </ActionDropdown>
          </div>
        );
      }
    }
  ];
}
